import $ from 'jquery';

const VALIDATE_CRITERIA_COUNT = 3;

export const profileComponent = {
	bindings: {
	},
	templateUrl: 'profile-template.html',
	transclude: true,
	controller: class ProfileComponent {
		constructor(UserHandlerService, $rootScope, notificationService, loaderService) {
			'ngInject';
			this.UserHandlerService = UserHandlerService;
			this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			this.model = {};
			this.messages = {};
			this.$rootScope = $rootScope;
			this.notificationService = notificationService;
			this.loaderService = loaderService;
		}

		$onInit() {
			$(document).on('mouseup', ()=>{
				$('#password').attr('type', 'password');
				$('#password_again').attr('type', 'password');
				$('#originalPassword').attr('type', 'password');
			});
			if (window.userInfo) {
				this.originalUserInfo = angular.copy(window.userInfo);
				this.model = window.userInfo;
			} else {
				this.notificationService.showError({message: 'hack'});
			}
		}

		setFieldVisible(id) {
			$('#' + id).attr('type', 'text');
		}

		showPassword($event) {
			$event.preventDefault();
			this.showAnotherPassword = !this.showAnotherPassword;
			if (!this.showAnotherPassword) {
				this.model.password = '';
				this.model.password_again = '';
			}
		}

		validatePw(modelName) {
			if (this.model[modelName]) {
				if (this.model[modelName].length >= 15) {
					this.profileForm[modelName].$setValidity('criteria', true);
				} else {
					let countOfCriteria = 0;
					if (/[\! "#\$%&'\(\)\*\+,-\.\/:;<=>\?@\[\]\^_`{\|}~]/.test(this.model[modelName])) {
						countOfCriteria++;
					}
					if (/[a-z]/.test(this.model[modelName])) {
						countOfCriteria++;
					}
					if (/[A-Z]/.test(this.model[modelName])) {
						countOfCriteria++;
					}
					if (/[0-9]/.test(this.model[modelName])) {
						countOfCriteria++;
					}
					let isValid = countOfCriteria >= VALIDATE_CRITERIA_COUNT;
					this.profileForm[modelName].$setValidity('criteria', isValid);
				}
				if (modelName == 'password_again') {
					let isTheSame = this.model[modelName] == this.model.password || !this.showAnotherPassword;
					this.profileForm[modelName].$setValidity('isTheSame', isTheSame);
				}
			}
		}

		saveChanges() {
			this.saveNameAndMail();
		}

		saveNameAndMail() {
			this.loaderService.show();
			this.messages = {};
			let params = {
				name: this.model.name,
				email: this.model.email,
				userId: this.model.userId,
				callback: window.location.origin + '/callback',
				marketing: this.model.marketing
			};
			this.UserHandlerService.saveNameAndEmail(params).then(() => {
				if (this.model.originalPassword && this.model.password &&  this.model.password_again &&  this.model.password_again ==  this.model.password) {
					this.saveNewPassword();
				} else {
					window.location.reload();
				}
			}).catch((error) => {
				this.loaderService.hide(1);
				this.notificationService.showError({message: error.data ? error.data.error : 'technicalError'});
			});
		}

		saveNewPassword() {
			let params = {
				password: this.model.originalPassword,
				newPassword: this.model.password,
				userId: this.model.userId,
				callback: window.location.origin + '/callback'
			};
			this.UserHandlerService.saveNewPassword(params).then(() => {
				window.location.reload();
			}).catch((error) => {
				this.loaderService.hide(1);
				this.notificationService.showError({message: error.data ? error.data.error : 'technicalError'});
			});
		}

		isTheSameAsOriginal() {
			return JSON.stringify(this.model) === JSON.stringify(this.originalUserInfo);
		}

		subscriptionChanged() {
			window.dataLayer.push({
				event: 'newsletterSubscribe'
			});
		}
	}
};
